interface ClientFormProps {
  displayName: string;
  phone: string;
  onChange: (data: { displayName: string; phone: string }) => void;
  onSubmit?: () => void;
  hideSubmitButton?: boolean;
}

export function ClientForm({ displayName, phone, onChange, onSubmit, hideSubmitButton }: ClientFormProps) {
  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
          Client Name
        </label>
        <input
          className="form-field max-w-none"
          placeholder="Enter client name"
          value={displayName}
          onChange={(e) => onChange({ displayName: e.target.value, phone })}
          data-testid="client-name-input"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
          Phone Number <span className="text-gray-500 dark:text-slate-500">(E.164)</span>
        </label>
        <input
          className="form-field max-w-none"
          placeholder="+16025551234"
          type="tel"
          value={phone}
          onChange={(e) => onChange({ displayName, phone: e.target.value })}
          data-testid="client-phone-input"
        />
      </div>
      {!hideSubmitButton && onSubmit && (
        <button
          onClick={onSubmit}
          disabled={!displayName.trim() || !phone.trim()}
          className="w-full px-4 py-2.5 rounded-lg bg-gradient-to-br from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white font-medium transition shadow-lg shadow-primary-500/25 disabled:opacity-60 disabled:cursor-not-allowed"
          data-testid="add-client-button"
        >
          Add Client
        </button>
      )}
    </div>
  );
}
